module.exports = __webpack_public_path__ + "img/mv05.fdc48d0a.png";